import '@/global';
import { SentryService } from '@/services/sentry';
import { environmentManager, type QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Outlet, useRouter } from '@tanstack/react-router';
import AntdApp from 'antd/es/app';
import ConfigProvider from 'antd/es/config-provider';
import enUS from 'antd/es/locale/en_US';
import { type FC, StrictMode, useEffect } from 'react';

interface Props {
  queryClient: QueryClient;
}

if (environmentManager.isServer()) {
  // eslint-disable-next-line no-console
  const originalError = console.error;
  // eslint-disable-next-line no-console
  console.error = (...args) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes('useLayoutEffect does nothing on the server')
    ) {
      return;
    }
    originalError(...args);
  };
}

const App: FC<Props> = ({ queryClient }) => {
  const router = useRouter();

  useEffect(() => {
    SentryService.init(router);
  }, [router]);

  return (
    <StrictMode>
      <ConfigProvider locale={enUS} theme={{ hashed: true }}>
        <AntdApp component={false}>
          <QueryClientProvider client={queryClient}>
            <Outlet />
          </QueryClientProvider>
        </AntdApp>
      </ConfigProvider>
    </StrictMode>
  );
};

export default App;
